import React from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import logo from "../../../Assets/Images/Logo.svg";
import email from "../../../Assets/Icons/email.svg";
import "./style.css";
import { resendVerificationEmail } from "../../../API/auth";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const handleResendVerification = async () => {
    console.log("Resend verification clicked");

    const response = await resendVerificationEmail();

    if (Math.floor(response?.status / 100) === 2) {
      message.success("Verification email sent!");
    } else {
      message.error(response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="verify">
      <div className="verify-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="verify-card">
          <div className="email-logo">
            <img src={email} alt="email" />
          </div>

          <div className="content-heading">Verify Your Email Address</div>
          <div className="sub-heading">
            We’ve sent a verification link to your email. Please click the link
            to activate your account and start building with Inbixio APIs.
          </div>

          <Button
            type="primary"
            htmlType="submit"
            className="submit-button"
            loading={loading}
            onClick={handleResendVerification}
          >
            Resend Verification Email
          </Button>

          <div className="sub-heading">
            Didn’t receive the email? Check your spam folder or wait a few
            minutes.
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
